import styled, { css } from 'styled-components';

import { FlexibleLinkComponent } from 'components/Links';

export const StyledLocaleLink = styled(FlexibleLinkComponent)<{ isCurrentLocale?: boolean }>`
  color: inherit;

  font-size: ${props => props.theme.fontSize.xxs};
  font-weight: ${props => props.theme.fontWeight.normal};
  line-height: ${props => props.theme.lineHeight.sm};
  height: ${props => props.theme.lineHeight.sm};
  text-decoration: none;

  ${({ isCurrentLocale, theme }) =>
    isCurrentLocale &&
    css`
      font-weight: ${theme.fontWeight.bold};
      text-decoration: underline;
      pointer-events: none;
      cursor: not-allowed;
    `}
`;
